/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import urls from "../../../../api/urls";
import API from "../../../../api";

import {
  message,
  Table,
  Input,
  Dropdown,
  Col,
  Menu,
  Select,
  Button,
  Tooltip,
  Space,
  Popconfirm,
} from "antd";
import Smcs_Loader from "../../../../assests/images/loader-new.gif";
import { serialNum, capitaliseWithHyphen } from "../../../../utils";
import search_icon from "../../../../assests/images/search-icon.svg";
import { QuestionCircleOutlined } from "@ant-design/icons";
import useCustomNavigate from "../../../../components/customNavigationHook";
import { FilterFilled } from "@ant-design/icons";
import { ReactComponent as Disable_icon } from "../../../../assests/images/SVG/disable.svg";
import { ReactComponent as Disable_Edit_icon } from "../../../../assests/images/SVG/disableEdit.svg";
import check_mark from "../../../../assests/images/SVG/check.svg";

import {
  CheckCircleOutlined,
  StopOutlined,
  SearchOutlined,
  MoreOutlined,
  //EyeOutlined,
} from "@ant-design/icons";

function ClientApprovalLeadList() {
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [tableData, setTableData] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useCustomNavigate();
  const [roleList, setRoleList] = useState([]);
  const [filteredColumn, setFilteredColumn] = useState("");
  const [filterRole, setFilterRole] = useState(null);
  const currentenv = process.env.REACT_APP_ENV;

  const role = [
    "ROLE_HOADMIN",
    "ROLE_HUBADMIN",
    "ROLE_CPADMIN",
    "ROLE_CPOPERATOR",
    "ROLE_CPDRIVER",
    "ROLE_HOOPERATOR",
    "ROLE_HUBOPERATOR",
    "ROLE_HUBDRIVER",
    "ROLE_CPFIELDEXECUTIVE",
    "ROLE_HOMARKETING",
    "ROLE_CPBOOKINGONLY",
  ];

  const roleMap = {
    ROLE_HOADMIN: "HO Admin",
    ROLE_HUBADMIN: "HUB Admin",
    ROLE_CPADMIN: "CP Admin",
    ROLE_CPOPERATOR: "CP Operator",
    ROLE_CPDRIVER: "CP Driver",
    ROLE_HOOPERATOR: "HO Operator",
    ROLE_HUBOPERATOR: "HUB Operator",
    ROLE_HUBDRIVER: "HUB Driver",
    ROLE_CPFIELDEXECUTIVE: "CP Field Executive",
    ROLE_HOMARKETING: "HO Marketing",
    ROLE_CPBOOKINGONLY: "CP Booking Only",
  };

  function getFormattedRole(roleKey) {
    return roleMap[roleKey] || roleKey;
  }

  useEffect(() => {
    //getTableData(pageNum, pageSize);
    setRoleList(
      role?.map((item) => ({
        value: item,
        label: getFormattedRole(item),
        key: item,
      }))
    );
    getTableData(`?pageNum=${pageNum}&pageSize=${pageSize}`);
  }, []);

  const { GET_USERS_MASTER_LIST, UPDATE_STAFF } = urls;

  const getTableData = async (page) => {
    setLoading(true);

    let response = await API.Api(
      GET_USERS_MASTER_LIST + page
    ).getWithUserNPremiseHeader();

    if (response?.status) {
      setLoading(false);
      setLoading(false);
      const res = response?.response?.data || [];
      setTableData(res);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    setFilterRole(selectedKeys?.[0] || null);
    confirm();

    if (selectedKeys?.[0]) {
      // const queryParams = `?pageNum=0&pageSize=20&city=${selectedKeys[0]}`;
      setFilteredColumn(dataIndex);
      getTableData(`?pageNum=0&pageSize=20&filter=${selectedKeys[0]}`);
    } else {
      setFilteredColumn(null);
      getTableData("?pageNum=0&pageSize=20");
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ confirm }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Select
          onChange={(e) => handleSearch([e], confirm, dataIndex)}
          showSearch
          allowClear
          placeholder="Select Role"
          options={roleList}
          style={{
            marginBottom: 8,
            width: "200px",
            display: "block",
          }}
        />
      </div>
    ),
    filterIcon: (filtered) => (
      <FilterFilled
        style={{
          color: filteredColumn === dataIndex ? "#1890ff" : undefined,
        }}
      />
    ),
  });

  const updateStaffOnboard = async (values) => {
    setLoading(true);
    let response = await API.Api(UPDATE_STAFF).putWithHeader(values);
    if (response?.status) {
      setLoading(false);
      message.success(response?.response?.data?.message);
      getTableData("?pageNum=0&pageSize=20");
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  const reRoute = (pathName) => {
    navigate(pathName);
  };

  let columns = [
    {
      title: "SI",
      width: 60,
      fixed: "left",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "User name",
      dataIndex: "firstName",
      key: "firstName",
      width: 80,
      render: (text, b) => formatText(text, 25),
      // render: (text, record) => {
      //   return text ? (
      //     <a
      //       onClick={() => reRoute(`/lead-details/APPROVED/${record?.userId}`)}
      //     >
      //       {text}
      //     </a>
      //   ) : (
      //     "N/A"
      //   );
      // },
    },
    {
      title: "Premise Name",
      dataIndex: "premiseName",
      key: "premiseName",
      render: (text, b) => formatText(text, 30),
      width: 120,
    },
    {
      title: "Email",
      dataIndex: "emailId",
      key: "emailId",
      width: 90,
      align: "left",
      render: (text, b) => formatText(text, 25),
    },
    {
      title: "Phone Number",
      dataIndex: "mobileNum",
      key: "mobileNum",
      width: 50,
      render: (text, b) => formatText(text, 10),
    },
    {
      title: "Onboarded Date",
      dataIndex: "creatDate",
      key: "creatDate",
      width: 80,
      render: (text, record) => text || "N/A",
    },

    {
      title: "Role",
      dataIndex: "roleAs",
      key: "roleAs",
      // filters: roleList,
      // filterMultiple: false,
      // filterSearch: true,
      ...getColumnSearchProps("roleAs"),
      width: 100,
      render: (text, record) => getFormattedRole(text) || "N/A",
    },

    {
      title: "Assigned to",
      dataIndex: "assignUser",
      key: "assignUser",
      width: 50,
      render: (text, record) => text || "N/A",
    },
    // {
    //   title: "Actions",
    //   key: "action",
    //   align: "center",
    //   className: "actions-col",
    //   // width: 150,

    //   render: (_, record) => {
    //     return record?.status ? (
    //       <Space size="middle">
    //         <Tooltip title="Disable" placement="bottom">
    //           <div className="view-all-staff">
    //             <Popconfirm
    //               title={
    //                 <span
    //                   className="test"
    //                   style={{
    //                     textTransform: "initial",
    //                   }}
    //                 >
    //                   Do you want to disable this Staff ?
    //                 </span>
    //               }
    //               cancelText="No"
    //               okText="Yes"
    //               icon={
    //                 <QuestionCircleOutlined
    //                   style={{
    //                     color: "red",
    //                   }}
    //                 />
    //               }
    //               onConfirm={() => handleDisable(record?.staffId)}
    //             >
    //               <p className="pointer" style={{ marginBottom: 0 }}>
    //                 <Disable_icon />
    //               </p>
    //             </Popconfirm>
    //           </div>
    //         </Tooltip>
    //       </Space>
    //     ) : (
    //       <Space size="middle">
    //         {/* <Tooltip title={"Edit"} placement="bottom"> */}
    //         <p style={{ marginBottom: 0 }}>
    //           <Disable_Edit_icon style={{ cursor: "not-allowed" }} />
    //         </p>
    //         {/* </Tooltip> */}
    //         <Tooltip title="Enable" placement="bottom">
    //           <Popconfirm
    //             title={
    //               <span
    //                 className="test"
    //                 style={{
    //                   textTransform: "initial",
    //                 }}
    //               >
    //                 Do you want to enable this Staff ?
    //               </span>
    //             }
    //             // description="Are you sure to Enable this staff?"
    //             okText="Yes"
    //             cancelText="No"
    //             icon={
    //               <QuestionCircleOutlined
    //                 style={{
    //                   color: "green",
    //                 }}
    //               />
    //             }
    //             onConfirm={() => handleEnable(record?.staffId)}
    //           >
    //             <p className="pointer">
    //               <img
    //                 src={check_mark}
    //                 style={{ width: "22px", marginBottom: "10px" }}
    //               />
    //             </p>
    //           </Popconfirm>
    //         </Tooltip>
    //       </Space>
    //     );
    //   },
    // },

    {
      title: "Status",
      dataIndex: "",
      key: "",
      width: 70,
      align: "center",
      filters: [
        { value: true, text: "Active" },
        { value: false, text: "In-Active" },
      ],
      filterMultiple: false,
      render: (text) =>
        text?.isEnable ? (
          <button className="active-button">Active</button>
        ) : (
          <button className="inActive-button">In-Active</button>
        ),
    },

    {
      title: "Actions",
      key: "action",
      align: "center",
      width: 100,
      render: (_, record) => {
        const menu = (
          <Menu
            items={[
              {
                key: "toggleStatus",
                label: record?.isEnable ? (
                  <span
                    onClick={() => handleEnableDisable(record?.userId, false)}
                  >
                    <StopOutlined style={{ color: "red", marginRight: 8 }} />
                    Disable
                  </span>
                ) : (
                  <span
                    onClick={() => handleEnableDisable(record?.userId, true)}
                  >
                    <CheckCircleOutlined
                      style={{ color: "green", marginRight: 8 }}
                    />
                    Enable
                  </span>
                ),
              },
            ]}
          />
        );

        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <Tooltip title="Actions">
              <MoreOutlined />
            </Tooltip>
          </Dropdown>
        );
      },
    },
  ];

  // if (currentenv == "prod") {
  //   columns = columns?.filter((item) => item.title !== "Actions");
  //   columns = columns?.filter((item) => item.title !== "Status");
  // }

  function handleEnableDisable(id, status) {
    let payload = {
      staffId: id,
      status: status,
    };
    updateStaffOnboard(payload);
  }
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const debounceTimeout = useRef(null);

  const handlePageChange = (pagination, filters) => {
    const roleFilter = filterRole ? `filter=${filterRole}` : "";

    const queryParams = `?pageNum=${pagination.current - 1}&pageSize=${
      pagination.pageSize
    }${roleFilter ? `&${roleFilter}` : ""}`;

    getTableData(queryParams);
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };
  const onSearch = (e) => {
    const currValue = e.target.value;
    setPageNum(0);
    setPageSize(pageSize);
    setInputSearchValue(currValue);
    const roleFilter = filterRole ? `filter=${filterRole}` : "";
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      //getClientApprovalList(0, 20, currValue);
      getTableData(
        `?pageNum=${pageNum}&pageSize=${pageSize}&search=${currValue}${
          roleFilter ? `&${roleFilter}` : ""
        }`
      );
    }, 500);
  };

  return (
    <div className="master-main-container lead-client-approval-list  ml-1">
      <div className="align-center">
        <div className=" fw-600"></div>
        <div className="text-right p-05">
          <Input
            placeholder="Search"
            bordered
            onChange={onSearch}
            style={{ borderRadius: "5px", height: "35px", width: "200px" }}
            suffix={<img src={search_icon} />}
          />
        </div>
      </div>
      <Table
        className="table-head-sticky"
        loading={{
          indicator: (
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          ),
          spinning: loading,
        }}
        // loading={loading}
        columns={columns}
        dataSource={tableData?.userListResponse}
        onChange={handlePageChange}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: tableData?.totalCount,
          pageSizeOptions: ["10", "20", "50", "100"],
          showSizeChanger: true,
          itemRender: itemRender,
        }}
      />
    </div>
  );
}

export default ClientApprovalLeadList;
